'use client';

import { Box, freddyTheme, Link } from '@coolblue-development/freddy';
import selectCategoryInBreadcrumbsTrigger from '@coolblue-development/ga4-events/triggers/Breadcrumbs/selectCategoryInBreadcrumbsTrigger';
import { ArrowLeft } from '@coolblue-development/icons';
import { useAnalytics } from '@coolblue-development/next-analytics/client';

import type { BackButtonMobileProps } from '../../Breadcrumbs.types';
import { StyledBackButtonContainer } from '../BackButton.styled';

export const BackButtonMobile = ({ hideFrom, breadcrumb }: BackButtonMobileProps) => {
  const { trackEvent } = useAnalytics();

  const trackingParams: Parameters<typeof selectCategoryInBreadcrumbsTrigger>[0] = {
    index: 1,
    total_indices: 1,
    url: breadcrumb?.url,
    redirect: 'back',
    sub_feature: 'horizontal_breadcrumbs'
  };

  return (
    <StyledBackButtonContainer hideFrom={hideFrom}>
      <Link
        href={breadcrumb?.absoluteUrl}
        startIcon={<ArrowLeft fill={freddyTheme.color.icon.base} />}
        onClick={() => trackEvent(selectCategoryInBreadcrumbsTrigger(trackingParams))}
      >
        <Box component='span'>{breadcrumb?.title}</Box>
      </Link>
    </StyledBackButtonContainer>
  );
};
